module.exports = __webpack_public_path__ + "static/media/newprofilebg.9c2bacc4.png";